import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
const StyledManageCookiesLink = styled(UILink).withConfig({
  displayName: "ManageCookies__StyledManageCookiesLink",
  componentId: "sc-109r8ik-0"
})(["color:#0b8484;", ""], props => props.shouldDiplayAccountLink && `
  margin-right: 40px;
`);
export const ManageCookies = ({
  shouldDiplayAccountLink
}) => {
  return /*#__PURE__*/_jsx(StyledManageCookiesLink, {
    className: "hs-footer-cookie-settings",
    shouldDiplayAccountLink: shouldDiplayAccountLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "legal.manageCookies"
    })
  });
};